import { useNavigate } from 'react-router-dom';
import '../styles/validacaoConvidados.css'

export default function ValidacaoConvidados() {

    const navigate = useNavigate();

    const irParaConfirmaCaptura = () => {
        navigate(`/captura-documento`);
    };

    return <div className="valida_documento">
        
        <img src='/images/validacao_imagem_new.jpg' alt='validação do documento' className="img_validacao" onClick={irParaConfirmaCaptura} />    
    
    </div>
}
